import { NextRouter } from "next/router"
import { shippingPagePath } from "../../../../root/routing/urls"
import { AppThunk } from "../../../../state/store"
import { updateBasketDrawerState } from "../../../ui/state/uiActions"
import { applyCheckoutLock } from "./lockCheckout"

export const goToCheckout = (router: NextRouter): AppThunk => async (
  dispatch,
  getState
) => {
  const basket = getState().checkout.basket
  if (!basket) {
    throw Error("Missing basket")
  }

  dispatch(updateBasketDrawerState(false))
  dispatch(applyCheckoutLock())
  router.push(shippingPagePath())
}
